export default __webpack_public_path__ + "static/media/twitterLogo.baebbf31.png";